import store from "@/store/index";
import { timeSlots15Min } from '@/constants/appConstants';

export function dateToyymmddFormat(item) {
  if (item == null) return '';

  let date = new Date(item);
  return date.toLocaleDateString('sv-SE', {});
}
export function convertToApiDate(date) {
  let d = new Date(date);
  return `${d.getFullYear()}${('0' + (d.getMonth() + 1)).slice(-2)}${('0' + d.getDate()).slice(
    -2,
  )}`;
}
export function dateToTimeStamp(item) {
  if (item == null) return null;
  let date = new Date(item);
  return date.toLocaleTimeString('sv-SE', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
function treatAsUTC(date) {
  let result = new Date(date);
  result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
  return result;
}
export function daysBetween(startDate, endDate) {
  let millisecondsPerDay = 24 * 60 * 60 * 1000;
  return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
}
export function addDays(date, days) {
  let result = new Date(date);
  result.setDate(result.getDate() + days);
  return dateToyymmddFormat(result);
}
export function isDateNotBetweenTwoDates(isThisDateBetween, datefrom, dateto) {
  datefrom.setHours(0, 0, 0);
  dateto.setHours(0, 0, 0);
  if (
    isThisDateBetween.getTime() <= dateto.getTime() &&
    isThisDateBetween.getTime() >= datefrom.getTime()
  )
    return false;
  return true;
}
// returns and array of unique dates for a specified period
export function getUniqueDates(startDateStr, endDateStr) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Check for invalid dates
  if (isNaN(startDate) || isNaN(endDate)) {
      throw new Error("Invalid start or end date");
  }

  const uniqueDates = [];

  for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
      uniqueDates.push(date.toISOString().split('T')[0]);
  }

  return uniqueDates;
}
export function showSecondsAsMMSS(seconds) {
  let minutes = Math.floor(seconds / 60);
  let remainingSeconds = seconds - minutes * 60;
  if (remainingSeconds < 10) remainingSeconds = '0' + remainingSeconds;
  return `${minutes}:${remainingSeconds}`;
}
export function filterMeasuresByPeriod(measures, period) {
  let filteredMeasures;
  if (period == 'consumptionperiod') {
    filteredMeasures = measures.filter(function (field) {
      return field.consolidation_days == -1;
    });
  } else {
    filteredMeasures = measures.filter(function (field) {
      return field.consolidation_days != -1;
    });
  }
  return filteredMeasures;
}

function processResultsBase(response, storeName, store) {
  // Preprocess data to maintain backward compatibility
  for (const [idx, row] of response.columnData.entries()) {
    row.measures = response.measureData[idx].measures;
    row.formatted_measures = response.measureData[idx].formatted_measures;
  }

  response.data = response.columnData;
  delete response.columnData;
  delete response.measureData;

  if (response?.data?.length > 0) {
    // Convert measures array to individual measure fields
    response.data.forEach(row => {
      row.measures.forEach((_, i) => {
        row[`measure_${i + 1}`] = row.formatted_measures[i];
      });
    });

    store.commit(`${storeName}/updateResults`, response);
    store.commit(`${storeName}/updateResultFields`, response.columns);

    if (response.summary) {
      store.commit(`${storeName}/setSummaryArray`, response.summary);
    }
  } else {
    store.commit(`${storeName}/updateResults`, []);
    store.commit(`${storeName}/updateResultFields`, []);
  }
}

export function processSiteResults(response, store) {
  processResultsBase(response, 'siteResults', store);
}

export function processResults(response, store) {
  processResultsBase(response, 'searchResults', store);
}

export function processCampaignResults(response, store) {
  processResultsBase(response, 'campaignResults', store);
}

export function sortOutColumnsBasedOnGroupBy(columns, groupById) {
  let keepTheseColumns = [];
  if (groupById == "nobody")
    return columns;
  keepTheseColumns.push(groupById);
  if (groupById == "filmCode") {
    keepTheseColumns.push('buyingAgency');
    keepTheseColumns.push('advertiser');
    keepTheseColumns.push('product');
  }
  columns = columns.filter(function (field) {
    if (this.includes(field.key) || field.key.includes("measure"))
      return field;
  }, keepTheseColumns);
  return columns;
}
export function sortResultTable(sortInfo, sortItems) {
  //sort numeric
  if (sortInfo.isNumber && sortInfo.sortDesc) {
    sortItems.sort((a, b) => {
      return parseNumberWithSpaces(b[sortInfo.sortBy]) - parseNumberWithSpaces(a[sortInfo.sortBy])
    })
  }
  else if (sortInfo.isNumber && !sortInfo.sortDesc) {
    sortItems.sort((a, b) => {
      return parseNumberWithSpaces(a[sortInfo.sortBy]) - parseNumberWithSpaces(b[sortInfo.sortBy])
    })
  }
  else {
    if (!sortInfo.sortDesc) {
      sortItems.sort((a, b) => {
        a = a[sortInfo.sortBy];
        b = b[sortInfo.sortBy];
        // Otherwise stringify the field data and use String.prototype.localeCompare
        return toString(a).localeCompare(toString(b), 'sv', { sensitivity: 'base' })
      })
    }
    else {
      sortItems.sort((a, b) => {
        a = a[sortInfo.sortBy];
        b = b[sortInfo.sortBy];
        // Otherwise stringify the field data and use String.prototype.localeCompare
        return toString(b).localeCompare(toString(a), 'sv', { sensitivity: 'base' })
      })
    }
  }
}
function parseNumberWithSpaces(str) {
  // Check if the input is already numeric
  if (!isNaN(str)) {
      // If it's numeric, return the value unchanged
      return parseFloat(str);
  }

  // Replace commas with dots and remove spaces from the string, then parse it as a number
  return parseFloat(str.replace(/,/g, '.').replace(/\s/g, ''));
}
export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
export function toString(value) {
  if (value === null || typeof value === 'undefined') {
    return ''
  } else if (value instanceof Object) {
    return Object.keys(value)
      .sort()
      .map(key => toString(value[key]))
      .join(' ')
  } else {
    return String(value)
  }
}
export function dynamicSort(sortInfo) {
  let sortOrder = 1
  if (sortInfo.sortDesc) sortOrder = -1
  return function (a, b) {
    let result = a[sortInfo.sortBy] < b[sortInfo.sortBy] ? -1 : a[sortInfo.sortBy] > b[sortInfo.sortBy] ? 1 : 0
    return result * sortOrder
  }
}
export function arrayToCsv(data) {
  return data
    .map(
      row =>
        row
          .map(String) // convert every value to String
          .map(v => v.replaceAll('"', '""')) // escape double colons
          .map(v => `"${v}"`) // quote it
          .join(";") // comma-separated
    )
    .join("\r\n") // rows starting on new lines
}

export const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
export function checkCookieConsent() {
  const consentCookie = document.cookie
    .split("; ")
    .find(row => row.startsWith("MMS_UserConsentStatus_OnlineAnalys="));

  return !!consentCookie;
}

export function consentToCookies() {
  const date = new Date();
  date.setMonth(date.getMonth() + 3);
  const cookieDomain = store.getters.getAppCookieDomain;
  document.cookie = `MMS_UserConsentStatus_OnlineAnalys=true; expires=${date.toUTCString()}; domain=${cookieDomain}; path=/; Secure; SameSite=Lax`;
}

export function hexToRgb(hex) {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

export function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
}

export function hslToRgb(h, s, l) {
  let r, g, b;

  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const hue2rgb = function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    let p = 2 * l - q;

    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

export function rgbToHsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;

  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    const delta = max - min;
    s = l > 0.5 ? delta / (2 - max - min) : delta / (max + min);

    switch (max) {
      case r: h = (g - b) / delta + (g < b ? 6 : 0); break;
      case g: h = (b - r) / delta + 2; break;
      case b: h = (r - g) / delta + 4; break;
    }
    h /= 6;
  }

  return [h, s, l];
}

export function adjustSaturation(s, factor) {
  return Math.min(s * factor, 1);
}

export function generateBrightnessLevels(primaryHex, levels) {
  const rgbValues = hexToRgb(primaryHex);
  const [h, s, l] = rgbToHsl(rgbValues.r, rgbValues.g, rgbValues.b);



  if (levels === 1) {
    // Adjust lightness and saturation for the primary color
    const adjustedLightness = Math.min(l + 0.2, 1); // Increase the lightness a bit, but ensure it doesn't go over 1
    const adjustedSaturation = Math.min(s + 0.1, 1); // Increase the saturation a bit, but ensure it doesn't go over 1
    const [r, g, b] = hslToRgb(h, adjustedSaturation, adjustedLightness);
    return [rgbToHex(r, g, b)];
  }


  let startLightness = l;
  if (levels > 4) {
    startLightness *= 0.75;  // darken the color
  }

  let adjustedSaturation = adjustSaturation(s, 0.8); // reduce the saturation by 20% for better contrast
  const results = [];

  const maxLightness = 0.85; // limit the brightness at 85%
  const lightnessStep = (maxLightness - startLightness) / (levels - 1);

  for (let i = 0; i < levels; i++) {
    const currentLightness = startLightness + i * lightnessStep;
    const [r, g, b] = hslToRgb(h, adjustedSaturation, currentLightness);
    results.push(rgbToHex(r, g, b));
  }

  return results;
}

export function generatePrimaryColors(number) {
  const predefinedColors = ["#35678A", "#B44A4A", "#1C6F1C", "#BA8E00", "#785AA0", "#9A5C20"];
  // const predefinedColors = ["#4472c4", "#ed8036", "#989898", "#ffc515", "#4DA375", "#8E6FA0"];

  if (number <= predefinedColors.length) {
    return predefinedColors.slice(0, number);
  }

  const results = [...predefinedColors];
  const hueStep = 1.0 / number;

  for (let i = predefinedColors.length; i < number; i++) {
    const [r, g, b] = hslToRgb(i * hueStep % 1, 0.5, 0.4); // 0.5 for saturation, 0.4 for lightness
    results.push(rgbToHex(r, g, b));
  }

  return results;
}
// Returns an array of arrays with colors by primary colors corresponding brightness versions
export function generateColorScheme(primaryColorCount, brightnessCount) {
  const primaries = generatePrimaryColors(primaryColorCount);
  const scheme = primaries.map(primary => generateBrightnessLevels(primary, brightnessCount));
  return scheme;
}



export function processDayConsumptionResults(receivedData, targetGroups) {
  // Extract the labels (time intervals) for the chart
  const labels = receivedData.timeIntervals;
  if (receivedData.dates[0] === "NoDate") {
    receivedData.dates[0] = ""
  }
  const colors = generateColorScheme(receivedData.measures.length, receivedData.dates.length)
  // Extract datasets from the measures
  let datasets = [];
  receivedData.measures.forEach((measure, measureIndex) => {
    measure.valuesByDate.forEach((values, dateIndex) => {
      datasets.push({
        label: `${receivedData.dates[dateIndex]} ${targetGroups[measureIndex]}`,
        targetGroup: `${targetGroups[measureIndex]}`,
        data: values,
        borderColor: colors[measureIndex][dateIndex],
        backgroundColor: colors[measureIndex][dateIndex],
        pointRadius: 0,
        pointHoverRadius: 2,
      });
    });
  });

  return {
    labels,
    datasets
  };
}

export function processTitleCodeConsumptionResults(data, targetGroups, uniqueDates) {
  const labels = uniqueDates.flatMap(date => 
      timeSlots15Min.map(slot => `${date} ${slot}`)
  );
  let datasets = [];
  const colors = generateColorScheme(data.length, targetGroups.length);
  data.forEach((titleCodeData, titleCodeIndex) => {
      targetGroups.forEach((group, groupIndex) => {
          let measureKey = `measure_${groupIndex + 1}`;
          let dataPoints = new Array(labels.length).fill(0);

          titleCodeData.measurePoint.forEach(point => {
              const dateTimeIndex = labels.indexOf(`${point.date.split('T')[0]} ${point.interval}`);
              if (dateTimeIndex !== -1 && point.keyMeasurePair[measureKey] !== undefined) {
                  dataPoints[dateTimeIndex] = point.keyMeasurePair[measureKey];
              }
          });

          datasets.push({
              label: `${titleCodeData.title} - ${titleCodeData.episodeNumber}`,
              targetGroup: group,
              data: dataPoints,
              borderColor: colors[titleCodeIndex][groupIndex],
              backgroundColor: colors[titleCodeIndex][groupIndex],
              pointRadius: 0,
              pointHoverRadius: 2,
          });
      });
  });

  
  return { labels, datasets };
}


export function downloadBlob(content, filename, contentType) {
  // Create a blob
  let BOM = "\uFEFF"
  let blob = new Blob([`${BOM}${content}`], { type: contentType })
  let url = URL.createObjectURL(blob)

  // Create a link to download it
  let pom = document.createElement("a")
  pom.href = url
  pom.setAttribute("download", filename)
  pom.click()
}